import { useRequest } from 'ahooks'

import { withdrawAuctionApplyApi } from '@eastcoal/api/trade/applyOperation/withdrawAuctionApply'

import { ConfirmButton } from '@eastcoal/common/components/Button/ConfirmButton'
import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { ApplyStatus } from '@eastcoal/shared/enums/ApplyStatus'

import { ApplyType } from '../../../../../enums/ApplyType'

import { ApplyWithdrawButtonProps } from './interface'

export const ApplyWithdrawButton = ({ record }: ApplyWithdrawButtonProps) => {
  const { message } = useFeedback()
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  const { refresh } = useRequest(
    () =>
      withdrawAuctionApplyApi({
        applyId: record.id
      }),
    {
      manual: true,
      onSuccess() {
        message.success('撤回成功')
        reload()
      }
    }
  )
  return record.applyType === ApplyType.INVITE &&
    record.status === ApplyStatus.WAIT_PARTICIPANT_CONFIRM ? (
    <ConfirmButton
      danger
      message='确定撤回吗？'
      type='link'
      onConfirm={refresh}
    >
      撤回
    </ConfirmButton>
  ) : null
}
